import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedDate, FormattedTime } from 'react-intl';
import { AppState } from '@tmapy/redux';
import { useMessage } from '@tmapy/intl';

import type { PublishsetListResponse } from '../../openapi/types';
import { useAppContext, useHistoryAction } from '../../hooks';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

import { priceListItemTypeMessages } from '../../priceList/components/priceListMessages';

import { AdminOnlyIcon } from './AdminOnlyIcon';
import { FormatTypeBadge } from './FormatTypeBadge';
import { PublishsetStateBadge } from './PublishsetStateBadge';

export const PublishsetListItem: React.FC<PublishsetListResponse> = (props) => {
  const { appType } = useAppContext();
  const formatMessage = useMessage();
  const hideTags = useSelector((state: AppState) => state.app.config.vydej?.hideTags);
  const customerType = useSelector((state: AppState) => state.app.config.customerType);
  const routeToPublishsetDetail = useHistoryAction('vydejPublishsetDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejPublishsetDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToPublishsetDetail();
      }
    },
    [routeToPublishsetDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>
        <div className='sg-a-d-f sg-a-ai-c sg-u-hsr-1'>
          <span>{props.name}</span>
          {customerType === 'ipr' && props.admin_only && <AdminOnlyIcon />}
        </div>
      </td>
      <td className='sg-a-ta-c'>
        <PublishsetStateBadge state={props.state} />
      </td>
      <td className='sg-a-ta-c'>{props.type && <FormatTypeBadge type={props.type} />}</td>
      <td>
        {props.price_list_item && (
          <div>
            {props.price_list_item.name}
            <div className='sg-u-type-sml sg-u-c-body-darkest'>
              {formatMessage.lookup(priceListItemTypeMessages, props.price_list_item.type) ??
                props.price_list_item.type}
            </div>
          </div>
        )}
      </td>
      {!hideTags && <td>{props.tags?.map((item) => item.name).join(', ')}</td>}
      <td>
        {props.creator && (
          <div>
            {props.creator.name} {props.creator.surname}
          </div>
        )}
        {props.created && (
          <div className='sg-a-mt-1/2 sg-a-ws-nw sg-u-c-body-darkest sg-a-fvn-tn'>
            <FormattedDate value={new Date(props.created)} />{' '}
            <FormattedTime value={new Date(props.created)} />
          </div>
        )}
      </td>
      <td>
        {props.editor && (
          <div>
            {props.editor.name} {props.editor.surname}
          </div>
        )}
        {props.edited && (
          <div className='sg-a-mt-1/2 sg-a-ws-nw sg-u-c-body-darkest sg-a-fvn-tn'>
            <FormattedDate value={new Date(props.edited)} />{' '}
            <FormattedTime value={new Date(props.edited)} />
          </div>
        )}
      </td>
    </tr>
  );
};
